import ProductItemsReport from "../../../components/@reports/ProductItemsReport";

import { routeTypes } from "../../../../../hooks/useSystemRoutes"

export default function ProductItemsReportPage() {

    return (
        <ProductItemsReport 
            routeType={routeTypes.admin}
        />
    )
}       